export default {
	getState: (state) => (attr) => {
		if(window.localStorage.getItem(attr)) {
			state[attr] = store.get(attr);
		}
		return state[attr];
	}
}


// WEBPACK FOOTER //
// ./src/store/getters.js